module.exports = __webpack_public_path__ + "static/bslGov_about2-d8da318d2bacea96f7f2eeb990b51283.png";